<div class="flex h-full min-h-0 w-full flex-col">
  <div class="flex flex-col gap-2 p-2">
    <div
      class="flex items-center justify-between gap-2 px-2 py-2 md:justify-start"
    >
      <div class="flex min-w-0 items-center gap-2">
        <img
          class="h-7 w-auto max-w-[9rem] object-contain object-left"
          [src]="logoUrl"
          [alt]="brandLabel || 'Logo'"
        />
        @if (brandLabel) {
          <span class="truncate text-xs font-medium text-gray-400">{{ brandLabel }}</span>
        }
      </div>
      <button
        type="button"
        class="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-md text-sidebar-foreground transition-colors hover:bg-sidebar-accent hover:text-sidebar-accent-foreground md:hidden"
        (click)="onToggleClick()"
        aria-label="Zavřít menu"
      >
        <i class="ri-menu-line text-base"></i>
      </button>
    </div>
  </div>

  <div class="flex min-h-0 flex-1 flex-col gap-2 overflow-auto p-2">
    <tc-navigation (menuItemClicked)="onMenuItemClicked()"></tc-navigation>
  </div>

  @if (user) {
    <div class="flex flex-col gap-2 border-t border-sidebar-border p-2">
      <div class="flex items-center gap-2 rounded-md p-2 text-sm">
        <div
          class="flex h-8 w-8 shrink-0 items-center justify-center overflow-hidden rounded-lg bg-sidebar-accent"
        >
          <img
            class="h-full w-full object-cover"
            [src]="getAvatarUrl()"
            [alt]="user.displayName"
          />
        </div>
        <div class="min-w-0 flex-1">
          <div
            class="truncate font-medium leading-none text-sidebar-foreground"
          >
            {{ user.displayName }}
          </div>
          @if (user.profileRoute) {
            <a
              [routerLink]="user.profileRoute"
              class="mt-1 block truncate text-xs text-sidebar-foreground/70 no-underline transition-colors hover:text-sidebar-foreground"
            >
              {{ profileLabel }}
            </a>
          }
        </div>
        @if (user.badge) {
          <span
            class="shrink-0 rounded-md border border-sidebar-border px-1.5 py-0.5 text-xs font-medium text-sidebar-foreground"
          >
            {{ user.badge }}
          </span>
        }
        <button
          type="button"
          class="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-md text-sidebar-foreground transition-colors hover:bg-sidebar-accent hover:text-sidebar-accent-foreground"
          [title]="logoutLabel"
          (click)="onLogoutClick()"
        >
          <i class="ri-logout-box-line text-base"></i>
        </button>
      </div>
    </div>
  }
</div>
